import translationQueries from "$/lib/queries/translation-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/translations")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(translationQueries.adminList())
    return { crumb: "Översättningar" }
  },
})
